//For use in Set dropdowns
function toggleTicketRow(e: any) {
	const expandedRows = this.state.expandedRows;
	const idx = e.currentTarget.getAttribute("index");
	const group = e.currentTarget.getAttribute("group");
	
	if (!expandedRows[group])
		expandedRows[group] = [];

	if (!expandedRows[group][idx])
		expandedRows[group][idx] = false;

	expandedRows[group][idx] = !expandedRows[group][idx];

	this.setState({ expandedRows: expandedRows });
}

export { toggleTicketRow };